import {useEffect, useMemo, useRef, useState} from "react"
import moment from "moment/moment"
import "moment/locale/ru"
import {extendMoment} from 'moment-range';
import style from "./index.module.css"
import back_arrow from "../../assets/images/icons/pagination-arrow-left.svg"
import next_arrow from "../../assets/images/icons/pagination-arrow-right.svg"
import search_icon from "../../assets/images/icons/icon-search.svg"
import person from "../../assets/images/img-person-five.png"

const test = [
    {
        userInfo: {
            text: "some man",
            imgSrc: '',
            job: 'PM'
        },
        color: '#FFD232',
        start: '2023.03.1',
        end: '2023.03.3',
    },
    {
        userInfo: {
            text: "some girl",
            imgSrc: '',
            job: 'PM'
        },
        color: '#F35D48',
        start: '2023.03.1',
        end: '2023.09.1'
    },
    {
        userInfo: {
            text: "some girl",
            imgSrc: '',
            job: 'PM'
        },
        color: '#4882F3',
        start: '2023.03.4',
        end: '2023.03.10'
    },
    {
        userInfo: {
            text: "some girl",
            imgSrc: '',
            job: 'PM'
        },
        color: '#92D839',
        start: '2023.02.1',
        end: '2023.02.10'
    },
    {
        userInfo: {
            text: "some girl",
            imgSrc: '',
            job: 'PM'
        },
        color: '#92D839',
        start: '2023.02.1',
        end: '2023.03.10'
    }
]
const duration_types = [
    {
        title: "Неделя",
        id: 1
    },
    {
        title: "Месяц",
        id: 2
    },
    {
        title: "Квартал 1",
        id: 3
    },
    {
        title: "Квартал 2",
        id: 4
    },
    {
        title: "Квартал 3",
        id: 5
    },
    {
        title: "Квартал 4",
        id: 6
    }
]


const TimeLine = () => {
    const cellWidth = useRef();
    const [width, setWidth] = useState(2)
    const [calendarData, setCalendarData] = useState({
        calendarStart: '2023.03.01',
        calendarType: 2
    })
    const [data, setData] = useState(test)
    const momentWithRange = extendMoment(moment);

    const calendarStart = moment(calendarData.calendarStart);
    const calendarType = calendarData.calendarType;

    const handlePrevClick = () => {
        let newDate, newCalendarType;

        switch (calendarType) {
            case 1: // Week
                newDate = calendarStart.clone().subtract(1, 'week');
                break;
            case 2: // Month
                newDate = calendarStart.clone().subtract(1, 'month');
                break;
            case 3: // First Quarter
                newDate = calendarStart.clone();
                newCalendarType = 6
                break;
            case 4: // Second Quarter
                newDate = calendarStart.clone();
                newCalendarType = 3
                break;
            case 5: // Third Quarter
                newDate = calendarStart.clone();
                newCalendarType = 4
                break;
            case 6: // Fourth Quarter
                newDate = calendarStart.clone();
                newCalendarType = 5
                break;

            default:
                newDate = calendarStart;
                newCalendarType = calendarType
        }

        setCalendarData({
            ...calendarData,
            calendarStart: newDate.format('YYYY.MM.DD'),
            calendarType: newCalendarType ? newCalendarType : calendarType
        });
    };
    const handleNextClick = () => {
        let newDate, newCalendarType;
        switch (calendarType) {
            case 1: // Week
                newDate = calendarStart.clone().add(1, 'week');
                break;
            case 2: // Month
                newDate = calendarStart.clone().add(1, 'month');
                break;
            case 3: // First Quarter
                newDate = calendarStart.clone();
                newCalendarType = 4
                break;
            case 4: // Second Quarter
                newDate = calendarStart.clone();
                newCalendarType = 5
                break;
            case 5: // Third Quarter
                newDate = calendarStart.clone();
                newCalendarType = 6
                break;
            case 6: // Fourth Quarter
                newDate = calendarStart.clone();
                newCalendarType = 3
                break;

            default:
                newDate = calendarStart;
                newCalendarType = calendarType
        }

        setCalendarData({
            ...calendarData,
            calendarStart: newDate.format('YYYY.MM.DD'),
            calendarType: newCalendarType ? newCalendarType : calendarType
        });

    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setData(test.filter(el=> el.userInfo.text.toLowerCase().includes(value.toLowerCase())))
    }

    useEffect(() => {
        if (cellWidth.current) {
            setWidth(cellWidth.current.offsetWidth);
        }
    }, [cellWidth, calendarData.calendarType])

    const month = useMemo(() => {
        const startDate = moment(calendarData.calendarStart).startOf('month');
        const daysInMonth = startDate.daysInMonth();

        return Array.from({ length: daysInMonth }, (_, index) => {
            const currentDate = startDate.clone().add(index, 'days');
            return currentDate.format('D dd');
        });
    }, [calendarData]);

    const week = useMemo(() => {
        const currentDate = moment(calendarData.calendarStart);
        const weekStart = currentDate.clone().startOf('isoWeek');
        const days = [];

        for (let i = 0; i <= 6; i++) {
            days.push(moment(weekStart).add(i, 'days').format("dddd, D"));
        }
        return days
    }, [calendarData])

    const getMonthsByQuarter = () => {
        const months = moment.months();
        const quarters = [];

        for (let i = 0; i < months.length; i += 3) {
            const quarterMonths = months.slice(i, i + 3);
            quarters.push(quarterMonths.join(', '));
        }

        return quarters;
    };

    const currentSelector = useMemo(() => {
        const monthsInQuarters = getMonthsByQuarter()
        const year = calendarStart.year()
        const month = calendarStart.format('MMM')
        if (calendarType === 3) {
            return monthsInQuarters[0];
        } else if (calendarType === 4) {
            return monthsInQuarters[1];
        } else if (calendarType === 5) {
            return monthsInQuarters[2];
        } else if (calendarType === 6) {
            return monthsInQuarters[3];
        } else {
            return (month + " " + year);
        }
    }, [calendarData])

    const getMonthsInQuarters = (year) => {
        const quarters = {
            firstQuarter: [],
            secondQuarter: [],
            thirdQuarter: [],
            fourthQuarter: [],
            firstQuarterWeeks: [],
            secondQuarterWeeks: [],
            thirdQuarterWeeks: [],
            fourthQuarterWeeks: []
        };

        const dateFormat = 'YYYY-MM-DD';

        const dateToStart = moment().year(year).startOf('year');
        const dateToEnd = moment().year(year).endOf('year');

        let momsrt = moment.utc(dateToStart);
        let momend = moment.utc(dateToEnd);

        while (momend.isAfter(momsrt)) {
            const week = [
                momsrt.startOf('isoWeek').format(dateFormat),
                momsrt.endOf('isoWeek').format(dateFormat)
            ];

            if (momsrt.quarter() === 1) {
                quarters.firstQuarterWeeks.push(week);
            } else if (momsrt.quarter() === 2) {
                quarters.secondQuarterWeeks.push(week);
            } else if (momsrt.quarter() === 3) {
                quarters.thirdQuarterWeeks.push(week);
            } else if (momsrt.quarter() === 4) {
                quarters.fourthQuarterWeeks.push(week);
            }

            momsrt.add(1, 'week');
        }

        Array.from({ length: 4 }, (_, index) => {
            const quarterStart = moment().year(year).quarter(index + 1).startOf('quarter');
            const quarterEnd = moment().year(year).quarter(index + 1).endOf('quarter');

            const quarterMonths = Array.from(moment().range(quarterStart, quarterEnd).by('month'), (m) =>
                m.format('MMM')
            );

            const weeksInQuarter = Array.from(moment().range(quarterStart, quarterEnd).by('week'), (w) => ({
                month: w.clone().startOf('month'),
                startDate: w.clone().startOf('week'),
                endDate: w.clone().endOf('week')
            }));

            const quarterWeeks = [];

            for (const month of quarterMonths) {
                const monthWeeks = weeksInQuarter.filter((week) => {
                    const weekRange = moment().range(week.startDate, week.endDate);
                    return Array.from(weekRange.by('day')).some((day) => day.format('MMM') === month);
                });


                if (monthWeeks.length > 0) {
                    const formattedWeeks = monthWeeks.map((week) => [
                        week.startDate.format('MMM').split('').filter((e, i)=> e!== '.' && i !==3).join('') + ' ' +
                        week.startDate.format('D'),
                        week.endDate.format('D')
                    ]);
                    quarterWeeks.push(...formattedWeeks);
                }
            }

            const uniqueWeeks = quarterWeeks.reduce((result, week) => {
                const existingWeek = result.find((w) => w[0] === week[0] && w[1] === week[1]);
                if (!existingWeek) {
                    result.push(week);
                }
                return result;
            }, []);

            switch (index) {
                case 0:
                    quarters.firstQuarter = uniqueWeeks.map((week) => `${week[0]}-${week[1]}`);
                    break;
                case 1:
                    quarters.secondQuarter = uniqueWeeks.map((week) => `${week[0]}-${week[1]}`);
                    break;
                case 2:
                    quarters.thirdQuarter = uniqueWeeks.map((week) => `${week[0]}-${week[1]}`);
                    break;
                case 3:
                    quarters.fourthQuarter = uniqueWeeks.map((week) => `${week[0]}-${week[1]}`);
                    break;
            }
        });

        return quarters;
    };

    const TimelineDurationPagination = () => {
        const currentYear = moment().year();
        const quarters = getMonthsInQuarters(currentYear);

        if (calendarData.calendarType === 2) {
            return month.map((item, index) => {
                return (
                    <>
                        {
                            <th className={style.table_month} ref={index === 0 ? cellWidth : null}>{item.split(' ').map(_item => (<><span>{_item}</span><br /></>))}</th>
                        }
                    </>

                )
            })
        } else if (calendarData.calendarType === 1) {
            return week.map((item1, index) => {
                return (
                    <>
                        {
                            <th className={style.table_week} ref={index === 0 ? cellWidth : null}>{item1}</th>
                        }
                    </>

                )
            })
        } else if (calendarData.calendarType === 3) {
            return quarters['firstQuarter'].map((item, index) => {
                return (
                    <>
                        {
                            <th className={style.table_quarter} ref={index === 0 ? cellWidth : null}>{item.split(' ').map(_item => (<><span>{_item}</span><br /></>))}</th>
                        }
                    </>

                )
            })
        } else if (calendarData.calendarType === 4) {
            return quarters['secondQuarter'].map((item, index) => {
                return (
                    <>
                        {
                            <th className={style.table_quarter} ref={index === 0 ? cellWidth : null}>{item.split(' ').map(_item => (<><span>{_item}</span><br /></>))}</th>
                        }
                    </>

                )
            })
        } else if (calendarData.calendarType === 5) {
            return quarters['thirdQuarter'].map((item, index) => {
                return (
                    <>
                        {
                            <th className={style.table_quarter} ref={index === 0 ? cellWidth : null}>{item.split(' ').map(_item => (<><span>{_item}</span><br /></>))}</th>
                        }
                    </>

                )
            })
        } else if (calendarData.calendarType === 6) {
            return quarters['fourthQuarter'].map((item, index) => {
                return (
                    <>
                        {
                            <th className={style.table_quarter} ref={index === 0 ? cellWidth : null}>{item.split(' ').map(_item => (<><span>{_item}</span><br /></>))}</th>
                        }
                    </>

                )
            })
        }
    }

    const sdf = useMemo(() => {
        const keys = [
            {
                calendarKey: "week",
                getObj: {
                    methodName: "weekday",
                    functionArgument: undefined,
                    addValue: 1
                }
            },
            {
                calendarKey: "month",
                getObj: {
                    methodName: "get",
                    functionArgument: "date",
                    addValue: 0
                }
            },
            {
                calendarKey: "firstQuarter",
                getObj: {
                    methodName: "get",
                    functionArgument: "date",
                    addValue: 0
                }
            },
            {
                calendarKey: "secondQuarter",
                getObj: {
                    methodName: "get",
                    functionArgument: "date",
                    addValue: 0
                }
            },
            {
                calendarKey: "thirdQuarter",
                getObj: {
                    methodName: "get",
                    functionArgument: "date",
                    addValue: 0
                }
            },
            {
                calendarKey: "fourthQuarter",
                getObj: {
                    methodName: "get",
                    functionArgument: "date",
                    addValue: 0
                }
            },
        ]
        const {calendarKey, getObj} = keys[calendarData.calendarType - 1];
        const calendarStart = moment(calendarData.calendarStart);
        const calendarEnd = moment(calendarData.calendarStart).endOf(calendarKey);
        const year = calendarStart.year();
        const quarters = getMonthsInQuarters(year);
        return data.map((item) => {
            let startDate = moment(item.start);
            let endDate = moment(item.end);
            let start = calendarStart[getObj.methodName](getObj.functionArgument) + getObj.addValue;
            let end = calendarEnd[getObj.methodName](getObj.functionArgument) + getObj.addValue;

            if (calendarKey === 'month' || calendarKey === 'week') {
                if(startDate.isBetween(calendarStart, calendarEnd) || startDate.isSame(calendarStart)) {
                    start = startDate[getObj.methodName](getObj.functionArgument) + getObj.addValue;
                } else {
                    start = null;
                }

                if(endDate.isBetween(calendarStart, calendarEnd) || endDate.isSame(calendarEnd)) {
                    end = endDate[getObj.methodName](getObj.functionArgument) + getObj.addValue;
                } else if (!start) {
                    end = null;
                }
            }

            if (calendarKey === 'firstQuarter') {
                quarters['firstQuarterWeeks'].map((week, index)=>{
                    const weekStart = moment(week[0])
                    const weekEnd = moment(week[1])

                    if (startDate.isBetween(weekStart, weekEnd) || startDate.isSame(weekStart) || startDate.isSame(weekEnd)) {
                        start = index + 1
                    }

                    if (endDate.isBetween(weekStart, weekEnd) || endDate.isSame(weekEnd) || endDate.isSame(weekStart)) {
                        end = index + 1
                    }
                    if (endDate.isAfter(weekEnd)){
                        end = quarters['firstQuarterWeeks'].length
                    }
                })
            }

            if (calendarKey === 'secondQuarter') {
                quarters['secondQuarterWeeks'].map((week, index)=>{
                    const weekStart = moment(week[0])
                    const weekEnd = moment(week[1])
                    if (endDate.isBefore(quarters['secondQuarterWeeks'][0][0])){
                        start = 0
                    }

                    if (startDate.isBetween(weekStart, weekEnd) || startDate.isSame(weekStart) || startDate.isSame(weekEnd)) {
                        start = index + 1
                    }

                    if (endDate.isBetween(weekStart, weekEnd) || endDate.isSame(weekEnd) || endDate.isSame(weekStart)) {
                        end = index + 1
                    } else if (endDate.isAfter(weekEnd)){
                        end = quarters['secondQuarterWeeks'].length
                    }
                })
            }

            if (calendarKey === 'thirdQuarter') {
                quarters['thirdQuarterWeeks'].map((week, index)=>{
                    const weekStart = moment(week[0])
                    const weekEnd = moment(week[1])

                    if (endDate.isBefore(quarters['thirdQuarterWeeks'][0][0])){
                        start = 0
                    }

                    if (startDate.isBetween(weekStart, weekEnd) || startDate.isSame(weekStart) || startDate.isSame(weekEnd)) {
                        start = index + 1
                    }

                    if (endDate.isBetween(weekStart, weekEnd) || endDate.isSame(weekEnd) || endDate.isSame(weekStart)) {
                        end = index + 1
                    }else if (endDate.isAfter(weekEnd)){
                        end = quarters['thirdQuarterWeeks'].length
                    }
                })
            }

            if (calendarKey === 'fourthQuarter') {
                quarters['fourthQuarterWeeks'].map((week, index)=>{
                    const weekStart = moment(week[0])
                    const weekEnd = moment(week[1])

                    if (endDate.isBefore(quarters['fourthQuarterWeeks'][0][0])){
                        start = 0
                    }

                    if (startDate.isBetween(weekStart, weekEnd) || startDate.isSame(weekStart) || startDate.isSame(weekEnd)) {
                        start = index + 1
                    }

                    if (endDate.isBetween(weekStart, weekEnd) || endDate.isSame(weekEnd) || endDate.isSame(weekStart)) {
                        end = index + 1
                    }else if (endDate.isAfter(weekEnd)){
                        end = quarters['fourthQuarterWeeks'].length
                    }
                })
            }

            return { start, end, color: item.color }
        })
    }, [data, calendarData])

    return (
        <div className={style.timeline}>
            <div className={style.timeline_monipulation}>
                <div className={style.calendar}>
                    <div className={style.part_title}><h4>Сотрудники</h4></div>
                    <div className={style.month}>
                        <h4 className={style.selected_month}>
                            {currentSelector}
                        </h4>
                        <div className={style.month_pagination}>
                            <div className={style.next_prev} onClick={handlePrevClick}>
                                <img src={back_arrow} />
                            </div>
                            <div className={style.next_prev} onClick={handleNextClick}>
                                <img src={next_arrow} />
                            </div>
                        </div>
                    </div>
                    <div className={style.timeline_duration}>

                        {
                            duration_types.map((item, index) => (
                                <div
                                    key={item.id}
                                    className={`${style.duration} ${item.id === calendarData.calendarType ? style.active : ''}`}
                                    onClick={() => setCalendarData(prev => ({...prev, calendarType: item.id}))}
                                >
                                    {item.title}
                                </div>
                            ))

                        }
                    </div>
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>
                            <div className={style.search}>
                                <img src={search_icon} alt="search icon" />
                                <input type="search" placeholder="Поиск" onChange={handleSearch} />
                            </div>
                        </th>
                        {TimelineDurationPagination()}
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map(item => {
                            return (
                                <tr>
                                    <td>
                                        <div className={style.employee}>
                                            <img src={person} />
                                            <p>
                                                {item.userInfo.text}
                                            </p>
                                        </div>
                                    </td>
                                    {
                                        TimelineDurationPagination().map(() => {
                                            return (
                                                <td></td>
                                            )
                                        })
                                    }
                                </tr>
                            )
                        })
                    }

                </tbody>
            </table>
            <div className={style.line}>
                {
                    sdf.map((item, index) => {
                        let leftSpace , widthCalc
                        if (calendarType > 2) {
                            leftSpace = width * (item.start - 1)
                            widthCalc = ((72 * (item.end - (item.start - 1))) - 4)
                        } else {
                            leftSpace = width * (item.start - 1)
                            widthCalc = ((width * (item.end - (item.start - 1))) - 4)
                        }
                        if(item.end && item.start) {
                            return (
                                <div
                                    className={style.duration_line}
                                    style={{
                                        top: ((index * 53)) + 'px',
                                        left: leftSpace + "px",
                                        width: widthCalc + "px",
                                        background: item.color,
                                    }}
                                />
                            )
                        }

                    })
                }

            </div>
        </div>
    )
}
export default TimeLine;
